import React, { Component } from 'react';
import electorate_pv_data from "../../store/electorates_party_vote.js";
import Share from "../Share/Share";
import { event as currentEvent } from "d3-selection";

var d3 = Object.assign(
  {},
  require("d3-selection"),
  require("d3-transition"),
  require("d3-array"),
  require("d3-axis"),
  require("d3-shape"),
  require("d3-format"),
  require("d3-scale"),
  require("d3-time-format"),
  require("d3-svg-annotation"),
  require("d3-svg-legend"),
  require("d3-jetpack"),
  require("d3-color"),
  require("d3-ease")
);

class ElectoratePVChart extends Component {
  componentDidMount() {
    this.setup();
  }

  componentDidUpdate(prevProps, prevState) {
    this.visComponents = this.makeVisComponents(this.props);
    this.update();
  }
  

  setup() {
    this.visComponents = this.makeVisComponents(this.props);

    const { innerM } = this.visComponents;

    this.g = d3
      .select(this.svg)
      .append("g")
      .attr("transform", `translate(${innerM.left} ${innerM.top - 10})`);

    this.pvote = this.g.append("g").classed("votes", true);
    this.yAxis = this.g.append("g").classed("y-axis axis", true);
    this.xAxis = this.g.append("g").classed("x-axis axis", true);
    this.xLabel = this.g.append("g").classed("x-label label", true);
    this.yLabel = this.g.append("g").classed("y-label label", true);

    this.defs = d3.select(this.svg).append("defs");

    this.tooltip = d3
    .select(".electorate-party-vote-chart")
    .append("div")
    .classed("tooltip3", true)
    .style("opacity", 0);

    this.update();
  }

  makeVisComponents(props) {
    const { height, width } = this.props;

    const innerM = { top: 30, bottom: 30, right: 10, left: 130 },
      innerW = width - innerM.left - innerM.right,
      innerH = height - innerM.top - innerM.bottom;


    const party_vote_data = electorate_pv_data.filter(d => d.electorate === this.props.electorate)

    party_vote_data.sort((a, b) => a.median - b.median);

    const parties = party_vote_data.map(d => d.party);

    const xDomain = [0,d3.max(party_vote_data, d => d.median) + 10];

    const xScale = d3.scaleLinear().domain(xDomain).range([10, innerW]);

    const yScale = d3
      .scaleBand()
      .domain(party_vote_data.map(d => d.party))
      .rangeRound([innerH, 0])
      .padding(0.2);

    const colorScale = d3
      .scaleOrdinal()
      .domain([
        "Conservative",
        "Mana",
        "United Future",
        "ACT",
        "Maori",
        "Green",
        "New Zealand First",
        "Labour",
        "National"
      ])
      .range([
        "#00AEEF",
        "#770808",
        "#501557",
        "#FDE401",
        "#EF4A42",
        "#098137",
        "#000000",
        "#D82A20",
        "#00529F"
      ]);

    return {
      innerM,
      xScale,
      yScale,
      party_vote_data,
      colorScale,
      parties,
      innerH,
      innerW
    };
  }

  update() {
    this.renderRects();
    this.renderAxes();
    this.renderLabels();
  }

  renderRects(props) {
    const {
      innerH,
      innerW,
      xScale,
      yScale,
      party_vote_data,
      colorScale
    } = this.visComponents;

    const colors = [
      { party: "Conservative", color: "#00AEEF", brighter: 4 },
      { party: "Mana", color: "#770808", brighter: 4 },
      { party: "United Future", color: "#501557", brighter: 4 },
      { party: "ACT", color: "#FDE401", brighter: 4 },
      { party: "Maori", color: "#EF4A42", brighter: 4 },
      { party: "Green", color: "#098137", brighter: 20 },
      { party: "New Zealand First", color: "#111111", brighter: 20 },
      { party: "Labour", color: "#D82A20", brighter: 20 },
      { party: "National", color: "#00529F", brighter: 20 }
    ];

    this.partyGradients = this.defs
      .selectAll("linearGradient")
      .data(colors)
      .enter()
      .append("linearGradient")
      .attr("id", d => "gradient-" + d.party.replace(/\s/g, "").toLowerCase())
      .attr("x1", "0%")
      .attr("y1", "0%")
      .attr("x2", "100%")
      .attr("y2", "0%");

    this.partyGradients
      .append("stop")
      .attr("offset", "0%")
      .attr("stop-color", d => d3.rgb(d.color).brighter(d.brighter))
      .attr("stop-opacity",0.3);

    this.partyGradients
      .append("stop")
      .attr("offset", "50%")
      .attr("stop-color", d => d3.rgb(d.color))
      .attr("stop-opacity",1);

    this.partyGradients
      .append("stop")
      .attr("offset", "100%")
      .attr("stop-color", d => d3.rgb(d.color).brighter(d.brighter))
      .attr("stop-opacity",0.3);

 
     const movePaths = d3.transition().duration(500).ease(d3.easeLinear);

    const bindRects = this.pvote
      .selectAll("rect")
      .data(party_vote_data, d => d.party + d.electorate);

    const enterRects = bindRects
      .enter()
      .append("rect")
      .attr("party", d => d.party)
      .attr("x", d => xScale(d.lower))
      .attr("y", d => yScale(d.party))
      .attr(
        "class",
        d => "rect" + " party-" + d.party.replace(/\s/g, "").toLowerCase()
      )
      .on("mouseover", d => {
        this.tooltip
          .transition()
          .duration(150)
          .style("opacity", 1);

        d3
          .selectAll(".rect")
          .transition()
          .duration(100)
          .st("opacity", 0.1);

        d3
          .selectAll(".rect.party-" + d.party.replace(/\s/g, "").toLowerCase())
          .transition()
          .duration(1000)
          .st("opacity", 1);

          this.tooltip.html(
            "Party: " + d.party + "<br/>"+
            "<small>" +
            "Lower estimate: " + d3.format(".03")(d.lower) + "</small>" +
            "<br/>" +
            "<b>" +
            "Median Projection: " + d3.format(".03")(d.median) + "%" +
            "</b>" +
            "<br/>" +
            "<small>" +
            "Upper estimate: " + d3.format(".03")(d.upper) + "</small>"
          )
      })
      .on("mouseout", d => {
        d3
          .selectAll(".rect")
          .transition()
          .duration(500)
          .st("opacity", 1);

        this.tooltip
          .transition()
          .duration(100)
          .style("left", currentEvent.pageX  + "px")
          .style("top", currentEvent.pageY + 10 + "px")
          .style("opacity", 0);
      })
      .transition(movePaths)
      .attr("width", d => xScale(d.upper - d.lower))
      .attr("height", yScale.bandwidth())
      .attr(
        "fill",
        d => "url(#gradient-" + d.party.replace(/\s/g, "").toLowerCase() + ")"
      )

      bindRects.merge(enterRects).transition(movePaths);

      bindRects.exit().remove();
  }

  renderAxes() {
    const {
      xScale,
      yScale,
      innerH,
      innerW,
      innerM,
      height
    } = this.visComponents;

    const tickNo = (innerW) => {
      if(innerW < 500) {
        return 3
      } else {
        return 7
      }
    }

    const xAxis = d3.axisBottom(xScale).tickSize(-innerH).ticks(tickNo(innerW));

    this.xAxis.attr("transform", `translate(0 ${innerH + 5} )`).call(xAxis);

    const yAxis = d3.axisLeft(yScale);

    this.yAxis.call(yAxis);
  }

  renderLabels() {
    const {
            xScale,
            yScale,
            party_vote_data,
            width,
            height,
            innerM,
            innerH,
            innerW
          } = this.visComponents;
          this.xLabel.selectAll("text").remove();
          this.yLabel.selectAll("text").remove();
      
          this.xLabel
            .append("text")
            .attr(
              "transform",
              `translate(${innerW} ${innerH})`
            )
            .style("text-anchor", "start")
            .attr("class", "axis-title")
            .attr("dy", "2em")
            .attr("x", -99)
            .attr("y", 15)
            .text("Party Vote (%)")
            .style("font-size", "0.8em")
            .style("font-weight", "100");

  }

  render() {
    const { height, width, electorate } = this.props;
    return (
      <div className="electorate-party-vote-chart">
        <svg id="electorate-party-vote-chart"
          width={width}
          height={450}
          ref={svg => {
            this.svg = svg;
          }}
        />
        <Share chart="electorate-party-vote-chart"
            desc={`Herald election model predicted party vote for ${this.props.electorate}`}
            params={{electorate: this.props.electorate}}/>
      </div>
    );
  }
}

export default ElectoratePVChart;




// WEBPACK FOOTER //
// ./src/components/ElectoratePV/ElectoratePVChart.js